import { useContext } from 'react';
import {
  AttachedFileLogo,
  DismissIcon,
  FileAttachmentFrame,
  FileDescription,
  FileInfoWrapper,
  FileName,
} from './FileAttachment.styled';
import { TeamsFxContext } from 'src/context/TeamsContext';

interface FileAttachmentProps {
  fileName: string;
  onClose: () => void;
}

export const FileAttachment = ({ fileName, onClose }: FileAttachmentProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  return (
    <FileAttachmentFrame contentEditable={false}>
      <>
        <AttachedFileLogo />
        <FileInfoWrapper>
          <FileName>{fileName}</FileName>
          {!isMobile && (
            <FileDescription>
              People in your organization with the link can view
            </FileDescription>
          )}
        </FileInfoWrapper>
      </>
      <DismissIcon onClick={onClose} />
    </FileAttachmentFrame>
  );
};
